import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function balanceSheet(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@balanceSheet/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@balanceSheet/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@balanceSheet/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}